import { ChairRollingIcon } from './ChairRollingIcon';

/**
 * author: Michael Irigoyen
 * id 822CF3D7-FEB4-4988-A037-0866756D4ADE
 * name chair-rolling
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chair-rolling.svg
 * tags
 * - Home Automation 
 */
export const StudyChairIcon = ChairRollingIcon;
export default StudyChairIcon